export default __webpack_public_path__ + "static/media/010-roundabout.68d0ffbd.png";